<script>
    export default {
        name: "DmarcMessages",

        template: "#dmarc-messages-template"
    }
</script>
